export default __webpack_public_path__ + "static/media/IndotexBG.fdc33223.webp";